<template>
  <div class="launch-page ultimate-theme" @scroll.passive="handleScroll">
    <HeaderMain />

    <main class="launch-page__main" ref="mainContainer">
      
      <!-- 1. MEGA HERO (SCROLL REACTIVE) -->
      <section class="mega-hero" ref="heroSection">
        <div class="mega-hero__glow" :style="mouseGlowStyle"></div>
        <div class="mega-hero__particles"></div>
        <div class="mega-hero__content container" :style="{ transform: `scale(${heroScale}) translateY(${scrolled * 0.4}px)`, opacity: heroOpacity }">
          <div class="mega-hero__badge wow-badge">
            <span class="badge-pulse"></span> <span class="badge-text">INFRAESTRUCTURA PARA ORGANIZERS QUE VENDEN DESEO</span>
          </div>
          
          <h1 class="mega-hero__title">
            <div class="title-line slide-left-wow" :style="{ transform: `translateX(${scrolled * -0.6}px)` }">LOS EVENTOS ÉPICOS</div>
            <div class="title-line slide-right-wow" :style="{ transform: `translateX(${scrolled * 0.6}px)` }"><span class="outline-text">NO VENDEN ENTRADAS.</span></div>
            <div class="title-line slide-up-wow glow-purple">VENDEN <em>FOMO.</em></div>
          </h1>
          
          <p class="mega-hero__subtitle fade-in-up">
            El ticketing genérico es para amateurs. FOMO es el motor operativo reservado para las productoras que dominan la escena. Si tu evento es el más codiciado, esta es la infraestructura que necesitas.
          </p>
          
          <div class="mega-hero__actions fade-in-up delay-1">
              <button @click="goToCreate" class="saas-premium-btn" type="button">
                <span>Lanzar mi evento con FOMO</span>
                <i class="fas fa-arrow-right"></i>
              </button>
              <button class="btn-mega-ghost wow-ghost" @click="goToLogin">
                Ya soy parte de FOMO
              </button>
          </div>
        </div>
      </section>

      <!-- 1.5. PREMIUM INFINITE SLIDER / TICKER -->
      <section class="premium-slider">
         <div class="slider-track">
           <div class="slider-item">✹ CHECKOUT ULTRARÁPIDO</div>
           <div class="slider-item">✹ DATA EN TIEMPO REAL</div>
           <div class="slider-item">✹ COMISIONES AUTOMATIZADAS</div>
            <div class="slider-item">✹ CÓDIGOS CON TRAZABILIDAD</div>
            <div class="slider-item">✹ CONTROL TOTAL DE AFORO</div>
            <div class="slider-item">✹ LIQUIDACIÓN CLARA</div>
           
           <!-- DUPLICATE FOR INFINITE LOOP -->
           <div class="slider-item">✹ CHECKOUT ULTRARÁPIDO</div>
           <div class="slider-item">✹ DATA EN TIEMPO REAL</div>
           <div class="slider-item">✹ COMISIONES AUTOMATIZADAS</div>
            <div class="slider-item">✹ CÓDIGOS CON TRAZABILIDAD</div>
            <div class="slider-item">✹ CONTROL TOTAL DE AFORO</div>
            <div class="slider-item">✹ LIQUIDACIÓN CLARA</div>
         </div>
      </section>

      <!-- 2. WOW REVEALS -->
      <section class="st-reveal-section" ref="stRevealSection">
        <div class="st-bg-gradient" :style="{ transform: `translateY(${scrolled * 0.1}px)` }"></div>
        <div class="st-reveal-container container">
          
          <div class="st-block reveal-element">
            <div class="st-content st-content--left">
              <div class="st-text">
                <div class="st-num-wow">01</div>
                <h2 class="st-title">Experiencia de compra impecable.</h2>
                 <p>Cada segundo de fricción mata intención de compra. FOMO te da un checkout rápido, claro y elegante para que tu público compre sin romper el impulso.</p>
              </div>
              <div class="st-visual ui-mockup-wow glass-panel">
                <div class="mockup-header">Checkout Express</div>
                <div class="mockup-body">
                  <div class="mock-line" style="width: 100%"></div>
                  <div class="mock-line pulse-line" style="width: 80%"></div>
                  <div class="mock-btn">Pagado <i class="fas fa-check"></i></div>
                </div>
              </div>
            </div>
          </div>

          <div class="st-block reveal-element">
            <div class="st-content st-content--right">
              <div class="st-visual ui-mockup-wow glass-panel dark-panel">
                <div class="mockup-stats">
                  <div class="stat-circle">
                    <svg viewBox="0 0 36 36"><path class="circle-bg" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/><path class="circle" stroke-dasharray="80, 100" d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"/></svg>
                    <div class="stat-perc">80%</div>
                  </div>
                  <div class="stat-lines">
                    <div class="mock-line"></div>
                    <div class="mock-line" style="width: 60%"></div>
                  </div>
                </div>
              </div>
              <div class="st-text">
                <div class="st-num-wow">02</div>
                 <h2 class="st-title">Tu red de RRPP, con data real.</h2>
                 <p>Deja atrás las listas confusas y las ventas ciegas. Asigna códigos y links propios, mide quién mueve tráfico, quién convierte y quién realmente empuja la preventa.</p>
              </div>
            </div>
          </div>

          <div class="st-block reveal-element">
            <div class="st-content st-content--left">
              <div class="st-text">
                <div class="st-num-wow">03</div>
                <h2 class="st-title">Control absoluto en puerta.</h2>
                 <p>Menos filas, menos caos y más sensación de evento premium desde la entrada. Valida accesos rápido, filtra cortesías y controla el aforo real sin perder ritmo operativo.</p>
              </div>
              <div class="st-visual ui-mockup-wow glass-panel scanner-mockup">
                <div class="scanner-frame">
                  <div class="scanner-laser"></div>
                  <i class="fas fa-qrcode qr-icon"></i>
                </div>
                <div class="scanner-status">Acceso Permitido</div>
              </div>
            </div>
          </div>

        </div>
      </section>

      <!-- 3. HORIZONTAL SCROLL: LA VITRINA -->
      <section v-if="isDesktop" class="horizontal-wrap" ref="horizontalWrap">
        <div class="sticky-box" ref="hSticky">
          <div class="h-scroll-header container">
             <h2 class="h-title wow-gradient-text">El estándar de oro.</h2>
             <p class="h-subtitle">Herramientas diseñadas por promotores, para promotores. Pensadas para que tu evento proyecte exclusividad y tu taquilla explote a otro nivel.</p>
          </div>
          
          <div class="scroll-track-container" ref="scrollContainer">
            <div class="scroll-track" :style="isDesktop ? { transform: `translateX(-${hScrollProgress}px)` } : {}">
               
               <!-- Card 1 -->
               <div class="h-card-slot">
                 <div class="h-card lux-bento reveal-element">
                   <div class="h-card-visual ticket-ui">
                     <div class="lux-glow"></div>
                     <div class="ui-ticket-3d">
                       <div class="ticket-top">
                         <strong>Fase 1: Early Bird</strong>
                         <span class="badge-urgency">Agotándose</span>
                       </div>
                       <div class="ticket-mid">
                         <span class="ui-price">$30 USD</span>
                         <div class="ui-bar"><div class="ui-fill anim-fill-1"></div></div>
                       </div>
                     </div>
                   </div>
                   <div class="h-card-text">
                     <h3>Fases Automáticas</h3>
                      <p>Controla preventas por etapas, cupos y cambios de precio sin improvisar. Cuando una fase se agota, la siguiente toma el relevo sin fricción.</p>
                   </div>
                 </div>
               </div>

               <!-- Card 2 -->
               <div class="h-card-slot">
                 <div class="h-card lux-bento reveal-element">
                   <div class="h-card-visual promo-ui">
                     <div class="lux-glow lux-glow-purple"></div>
                     <div class="magic-promo-box">
                       <div class="floating-tag f-tag-1"><i class="fas fa-tag"></i> FOMO50</div>
                       <div class="floating-tag f-tag-2 hidden-style"><i class="fas fa-lock"></i> VIP HIDDEN</div>
                       <div class="floating-tag f-tag-3"><i class="fas fa-percent"></i> DESC</div>
                     </div>
                   </div>
                   <div class="h-card-text">
                     <h3>Códigos Dinámicos</h3>
                      <p>Activa descuentos, accesos ocultos y campañas privadas sin perder orden. Vende con exclusividad, segmenta audiencias y abre puertas solo a quien tú decidas.</p>
                   </div>
                 </div>
               </div>

               <!-- Card 3 -->
               <div class="h-card-slot">
                 <div class="h-card lux-bento reveal-element">
                   <div class="h-card-visual stats-ui">
                     <div class="lux-glow lux-glow-green"></div>
                     <div class="chart-3d">
                       <div class="bar-3d" style="height: 40%">
                         <div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div>
                       </div>
                       <div class="bar-3d" style="height: 65%">
                         <div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div>
                       </div>
                       <div class="bar-3d highlight-bar" style="height: 100%">
                         <div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div>
                       </div>
                     </div>
                   </div>
                   <div class="h-card-text">
                     <h3>Liquidación Transparente</h3>
                     <p>Tu dinero a un clic. Desembolsos rápidos y directos para mantener tu flujo de caja a tope durante toda la producción del evento.</p>
                   </div>
                 </div>
               </div>

               <!-- Card 4 -->
               <div class="h-card-slot">
                 <div class="h-card lux-bento reveal-element">
                   <div class="h-card-visual integration-ui">
                     <div class="lux-glow lux-glow-blue"></div>
                     <div class="grid-mesh-bg"></div>
                     <div class="fomo-core-logo">
                       <span>F</span>
                     </div>
                     <div class="orbit orbit-1"></div>
                     <div class="orbit orbit-2"></div>
                   </div>
                   <div class="h-card-text">
                     <h3>El Centro de Mando</h3>
                      <p>Etapas, códigos, RRPP, tráfico, ventas y operación en un solo lugar. Menos caos operativo, más control para decidir rápido.</p>
                   </div>
                 </div>
               </div>

            </div>
          </div>
        </div>
      </section>

      <section v-else class="mobile-story-wrap">
        <div class="h-scroll-header container mobile-story-header">
          <h2 class="h-title wow-gradient-text">El estándar de oro.</h2>
          <p class="h-subtitle">Herramientas diseñadas por promotores, para promotores. Pensadas para que tu evento proyecte exclusividad y tu taquilla explote a otro nivel.</p>
        </div>

        <div class="mobile-story-stack">
          <section class="mobile-story-step reveal-element">
            <div class="container">
              <div class="h-card lux-bento">
                <div class="h-card-visual ticket-ui">
                  <div class="lux-glow"></div>
                  <div class="ui-ticket-3d">
                    <div class="ticket-top">
                      <strong>Fase 1: Early Bird</strong>
                      <span class="badge-urgency">Agotándose</span>
                    </div>
                    <div class="ticket-mid">
                      <span class="ui-price">$30 USD</span>
                      <div class="ui-bar"><div class="ui-fill anim-fill-1"></div></div>
                    </div>
                  </div>
                </div>
                <div class="h-card-text">
                  <h3>Fases Automáticas</h3>
                  <p>Sube el precio de los tiers sin tocar código. Define el aforo y el sistema hace el salto automático hacia la siguiente etapa de preventa.</p>
                </div>
              </div>
            </div>
          </section>

          <section class="mobile-story-step reveal-element">
            <div class="container">
              <div class="h-card lux-bento">
                <div class="h-card-visual promo-ui">
                  <div class="lux-glow lux-glow-purple"></div>
                  <div class="magic-promo-box">
                    <div class="floating-tag f-tag-1"><i class="fas fa-tag"></i> FOMO50</div>
                    <div class="floating-tag f-tag-2 hidden-style"><i class="fas fa-lock"></i> VIP HIDDEN</div>
                    <div class="floating-tag f-tag-3"><i class="fas fa-percent"></i> DESC</div>
                  </div>
                </div>
                <div class="h-card-text">
                  <h3>Códigos Dinámicos</h3>
                  <p>Descuentos fijos, porcentuales o códigos de acceso ocultos para listas ultra exclusivas.</p>
                </div>
              </div>
            </div>
          </section>

          <section class="mobile-story-step reveal-element">
            <div class="container">
              <div class="h-card lux-bento">
                <div class="h-card-visual stats-ui">
                  <div class="lux-glow lux-glow-green"></div>
                  <div class="chart-3d">
                    <div class="bar-3d" style="height: 40%"><div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div></div>
                    <div class="bar-3d" style="height: 65%"><div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div></div>
                    <div class="bar-3d highlight-bar" style="height: 100%"><div class="bar-face front"></div><div class="bar-face top"></div><div class="bar-face right"></div></div>
                  </div>
                </div>
                <div class="h-card-text">
                  <h3>Liquidación Transparente</h3>
                  <p>Tu dinero a un clic. Desembolsos rápidos y directos para mantener tu flujo de caja a tope durante toda la producción del evento.</p>
                </div>
              </div>
            </div>
          </section>

          <section class="mobile-story-step reveal-element">
            <div class="container">
              <div class="h-card lux-bento">
                <div class="h-card-visual integration-ui">
                  <div class="lux-glow lux-glow-blue"></div>
                  <div class="grid-mesh-bg"></div>
                  <div class="fomo-core-logo"><span>F</span></div>
                  <div class="orbit orbit-1"></div>
                  <div class="orbit orbit-2"></div>
                </div>
                <div class="h-card-text">
                  <h3>El Centro de Mando</h3>
                  <p>Conecta fechas, preventas, cortesías y métricas bajo un ecosistema centralizado. El control total de tu taquilla, digno de los mejores.</p>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <!-- 4. TRANSPARENT PRICING CON WOW -->
      <section class="mega-pricing">
        <div class="pricing-bg-fx"></div>
        <div class="container pricing-grid">
          <div class="pricing-content reveal-element">
            <h2 class="wow-gradient-text">Transparencia brutal.<br/>Condiciones top.</h2>
            <p>Usar la infraestructura FOMO cuesta $0. Solo cobramos un fee transparente de <strong>$1 USD + pasarela</strong> por entrada vendida. Creemos firmemente que el dinero de la taquilla te pertenece a ti.</p>
            <ul class="pricing-list">
               <li><i class="fas fa-check-circle glow-icon"></i> Fee 100% trasladable al comprador final.</li>
               <li><i class="fas fa-check-circle glow-icon"></i> Eventos o cortesías gratuitas sin trampas ($0 USD).</li>
               <li><i class="fas fa-check-circle glow-icon"></i> Liquidación rápida y sin trabas para la productora.</li>
            </ul>
          </div>
          <div class="pricing-card-wrapper reveal-element">
            <div class="pricing-glass-card wow-tilt">
              <div class="glass-glare"></div>
              <div class="price-display">
                <span class="currency">$</span>
                <span class="amount">1</span>
                <span class="period">USD</span>
              </div>
              <p class="fee-text">+ Fee procesador de pagos</p>
              
               <button @click="goToCreate" class="event-view__serious-button event-view__action event-view__action--primary full-width-wow" type="button">
                <span class="event-view__action-glow"></span>
                <span class="event-view__action-clip">
                  <span class="event-view__action-ring"></span>
                </span>
                <span class="event-view__action-plate"></span>
                <span class="event-view__action-inner">
                  <span class="event-view__action-copy">Crear mi primer evento</span>
                  <span class="event-view__action-icon"><i class="fas fa-arrow-right"></i></span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </section>

      <!-- 5. FINAL PUSH CTA EXTREMO -->
      <section class="mega-cta">
        <div class="mega-cta-bg"></div>
        <div class="container cta-content-box reveal-element">
          <h2 class="megatext-reveal">
            Tus eventos ya no necesitan marketing.<br/> <span class="highlight-soldout">Necesitan FOMO.</span>
          </h2>
          <p class="mega-cta__support">Porque cuando deseo, conversión y control trabajan juntos, el sold out deja de ser casualidad.</p>
          <div class="hero-actions">
            <button @click="goToCreate" class="saas-premium-btn btn-massive" type="button">
              <span>Crear mi evento ahora</span>
              <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </section>
      
    </main>

    <FooterMain />

  </div>
</template>

<script>
import FooterMain from '@/components/FooterMain.vue'
import HeaderMain from '@/components/HeaderMain.vue'

export default {
  name: 'LaunchEventView',
  components: {
    HeaderMain,
    FooterMain,
  },
  data() {
    return {
      scrolled: 0,
      heroScale: 1,
      heroOpacity: 1,
      hScrollProgress: 0,
      mouseX: 0,
      mouseY: 0,
      isDesktop: true
    }
  },
  computed: {
    mouseGlowStyle() {
      return {
        background: `radial-gradient(circle at ${this.mouseX}px ${this.mouseY}px, rgba(112, 0, 255, 0.4) 0%, transparent 50%)`
      }
    }
  },
  mounted() {
    this.checkDevice();
    window.addEventListener('resize', this.checkDevice, { passive: true });
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    window.addEventListener('mousemove', this.handleMouseMove, { passive: true });
    // Initial reveals
    setTimeout(() => { this.handleScroll(); }, 100);
  },
  unmounted() {
    window.removeEventListener('resize', this.checkDevice);
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('mousemove', this.handleMouseMove);
  },
  methods: {
    checkDevice() {
      this.isDesktop = window.innerWidth > 900;
    },
    handleMouseMove(e) {
      if(this.$refs.heroSection) {
        const rect = this.$refs.heroSection.getBoundingClientRect();
        if(e.clientY < rect.bottom && e.clientY > rect.top) {
           this.mouseX = e.clientX;
           this.mouseY = e.clientY - rect.top;
        }
      }
    },
    handleScroll() {
      const scrollY = window.scrollY;
      this.scrolled = scrollY;
      
      // Auto-reveal elements
      const reveals = this.$refs.mainContainer ? this.$refs.mainContainer.querySelectorAll('.reveal-element') : document.querySelectorAll('.reveal-element');
      reveals.forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.top <= window.innerHeight * 0.95) {
          el.classList.add('is-visible');
        }
      });

      // Hero Scale & Fade
      this.heroScale = 1 + scrollY * 0.0003;
      this.heroOpacity = Math.max(0, 1 - scrollY * 0.0012);

      // JS Bulletproof Sticky Pinner (Ignora bugs de overflow hidden nativos)
      const pinElement = (wrap, st) => {
        if (!wrap || !st) return;
        const rect = wrap.getBoundingClientRect();
        if (rect.top <= 0 && rect.bottom >= window.innerHeight) { // Pinned
          st.style.position = 'fixed'; st.style.top = '0px'; st.style.bottom = 'auto'; st.style.left = '0px'; st.style.width = '100%'; st.style.zIndex = '50';
        } else if (rect.top > 0) { // Above
          st.style.position = 'absolute'; st.style.top = '0px'; st.style.bottom = 'auto'; st.style.left = '0px'; st.style.width = '100%'; st.style.zIndex = '1';
        } else { // Below
          st.style.position = 'absolute'; st.style.top = 'auto'; st.style.bottom = '0px'; st.style.left = '0px'; st.style.width = '100%'; st.style.zIndex = '1';
        }
      };

      if (!this.isDesktop) {
        this.hScrollProgress = 0;
        if (this.$refs.hSticky) {
          this.$refs.hSticky.style.position = 'relative';
          this.$refs.hSticky.style.top = 'auto';
          this.$refs.hSticky.style.bottom = 'auto';
          this.$refs.hSticky.style.left = 'auto';
          this.$refs.hSticky.style.width = 'auto';
          this.$refs.hSticky.style.zIndex = '1';
        }
        return;
      }

      // Horizontal Scroll Math (solo desktop)
      pinElement(this.$refs.horizontalWrap, this.$refs.hSticky);
      
      if (this.$refs.horizontalWrap && this.$refs.scrollContainer) {
        const wrapRect = this.$refs.horizontalWrap.getBoundingClientRect();
        const maxScrollDistance = wrapRect.height - window.innerHeight;
        
        const track = this.$refs.scrollContainer.querySelector('.scroll-track');
        if (track && maxScrollDistance > 0) {
          const maxTranslate = Math.max(0, track.scrollWidth - window.innerWidth + 160);
          
          if (wrapRect.top <= 0 && wrapRect.bottom >= window.innerHeight) {
            let progress = -wrapRect.top / maxScrollDistance;
            this.hScrollProgress = Math.max(0, Math.min(maxTranslate, progress * maxTranslate));
          } else if (wrapRect.top > 0) {
            this.hScrollProgress = 0;
          } else {
            this.hScrollProgress = maxTranslate;
          }
        }
      }
    },
    goToCreate() {
      this.$router.push({ name: 'event-creation' });
    },
    goToLogin() {
      this.$router.push({ name: 'preloader', query: { next: '/events' } });
    }
  }
}
</script>

<style scoped>
/* ==========================================================================
   0. OVERRIDES GLOBALES EN ESTA VISTA
   ========================================================================== */
.launch-page {
  overflow-x: hidden !important;
  width: 100%;
}
.launch-page :deep(.glass-topbar) {
  position: absolute !important;
  left: 0; right: 0;
  margin-left: auto; margin-right: auto;
  z-index: 100;
}

/* ==========================================================================
   1. VARIABLES GLOBALES DE LA VISTA
   ========================================================================== */
/* ==========================================================================
   LUXURY THEME OVERRIDES & FONTS
   ========================================================================== */
.ultimate-theme {
  --bg-dark: #050505;
  --bg-panel: rgba(20, 20, 22, 0.7);
  --bg-panel-solid: #0d0d0f;
  --border-glass: rgba(255, 255, 255, 0.08);
  --text-pure: #ffffff;
  --text-faint: #9999a1;
  --brand-purple: #7000ff;
  --brand-purple-glow: rgba(112, 0, 255, 0.8);
  --brand-cyan: #00e5ff;
  
  background-color: var(--bg-dark);
  color: var(--text-pure);
  font-family: 'Space Grotesk', 'Inter', -apple-system, sans-serif;
  /* overflow-x: hidden; REMOVED TO PREVENT KILLING CSS POSITION: STICKY */
  -webkit-font-smoothing: antialiased;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 40px;
}
@media(max-width: 768px) { .container { padding: 0 20px; } }

/* ==========================================================================
   EXTREME WOW TEXTS & BUTTONS
   ========================================================================== */
.wow-gradient-text {
  background: linear-gradient(135deg, #fff 0%, #a5a5b0 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.glow-purple {
  color: #fff;
  text-shadow: 0 0 40px var(--brand-purple-glow), 0 0 10px rgba(255,255,255,0.5);
}
.glow-purple em {
    font-style: normal;
    color: var(--brand-purple);
}

.hero-btn-wow {
  padding: 0 40px !important;
  height: 60px !important;
  font-size: 1.1rem !important;
  box-shadow: 0 0 40px rgba(112,0,255,0.4) !important;
}
.hero-btn-wow:hover {
  box-shadow: 0 0 60px rgba(112,0,255,0.6) !important;
  transform: scale(1.02);
}

.btn-mega-ghost {
  background: rgba(255,255,255,0.02);
  backdrop-filter: blur(10px);
  color: #fff;
  padding: 0 36px;
  height: 60px;
  font-size: 1.1rem;
  font-weight: 600;
  border-radius: 999px;
  border: 1px solid rgba(255,255,255,0.1);
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.btn-mega-ghost:hover {
  background: rgba(255,255,255,0.08);
  border-color: rgba(255,255,255,0.3);
  transform: translateY(-2px);
}

/* Base button structure (borrowed styles to ensure consistency if global isn't loaded correctly here) */
.event-view__serious-button {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  cursor: pointer;
  font-family: inherit;
  border-radius: 999px;
  transition: all 0.3s ease;
}
.event-view__action--primary .event-view__action-plate {
  position: absolute; inset: 0;
  background: var(--brand-purple);
  border-radius: inherit;
  z-index: 1;
}
.event-view__action--primary .event-view__action-ring {
  position: absolute; inset: -1px;
  border-radius: inherit;
  border: 1px solid rgba(255,255,255,0.2);
  z-index: 2;
}
.event-view__action-inner {
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #fff;
  font-weight: 700;
}

/* ==========================================================================
   1. MEGA HERO INTENSE
   ========================================================================== */
.mega-hero {
  height: auto;
  min-height: 100vh;
  padding: 160px 0 60px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
  overflow: hidden;
  background: radial-gradient(circle at center, #0a0a0f 0%, #000 100%);
}

.mega-hero__particles {
  position: absolute; inset:0;
  background-image: radial-gradient(rgba(255,255,255,0.1) 1px, transparent 1px);
  background-size: 40px 40px;
  opacity: 0.3;
  animation: bgPan 40s linear infinite;
}
@keyframes bgPan {
  from { background-position: 0 0; }
  to { background-position: 400px 400px; }
}

.mega-hero__glow {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  pointer-events: none;
  z-index: 0;
  transition: background 0.1s ease;
}

.mega-hero__content {
  position: relative;
  z-index: 10;
  will-change: transform, opacity;
}

.wow-badge {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  background: rgba(112,0,255,0.1);
  border: 1px solid rgba(112,0,255,0.3);
  padding: 8px 20px;
  border-radius: 999px;
  margin-bottom: 40px;
  box-shadow: 0 0 20px rgba(112,0,255,0.2) inset;
}
.badge-pulse {
  width: 8px; height: 8px; border-radius: 50%;
  background: #fff;
  box-shadow: 0 0 10px #fff;
  animation: pulseLight 2s infinite;
}
@keyframes pulseLight { 0%,100%{opacity:1;} 50%{opacity:0.3;} }
.badge-text { font-weight: 700; letter-spacing: 0.1em; font-size: 0.75rem; color: #fff; }

.mega-hero__title {
  font-size: clamp(3rem, 8vw, 7.5rem);
  font-weight: 900;
  line-height: 1;
  letter-spacing: -0.04em;
  margin-bottom: 30px;
  perspective: 1000px;
}
.title-line { will-change: transform; display: block; }
.outline-text {
  color: transparent;
  -webkit-text-stroke: 1px rgba(255,255,255,0.6);
  text-shadow: none;
}
.slide-up-wow {
  animation: slideUpFade 1.2s cubic-bezier(0.16,1,0.3,1) forwards;
}

.mega-hero__subtitle {
  font-size: clamp(1.1rem, 2vw, 1.35rem);
  color: var(--text-faint);
  max-width: 650px;
  margin: 0 auto 50px;
  line-height: 1.6;
}

.mega-hero__actions {
  display: flex;
  gap: 20px;
  justify-content: center;
}
@media(max-width: 600px) {
  .mega-hero__actions { flex-direction: column; align-items: stretch; }
  .hero-btn-wow, .btn-mega-ghost { width: 100%; }
}

/* Animations that trigger on load */
.fade-in-up { opacity: 0; transform: translateY(30px); animation: slideUpFade 1s cubic-bezier(0.16,1,0.3,1) forwards; }
.delay-1 { animation-delay: 0.3s; }

@keyframes slideUpFade {
  to { opacity: 1; transform: translateY(0); }
}

.hero-subtitle {
  font-size: 1.25rem; font-family: 'Inter', sans-serif;
  color: var(--text-faint); max-width: 700px;
  margin: 0 auto 50px; line-height: 1.6;
}

/* ==========================================================================
   1.5 PREMIUM INFINITE SLIDER / TICKER
   ========================================================================== */
.premium-slider {
  width: 100%;
  overflow: hidden;
  position: relative;
  background: rgba(14, 12, 18, 0.9);
  padding: 18px 0;
  display: flex;
  align-items: center;
  z-index: 20;
}

.slider-track {
  display: flex;
  align-items: center;
  gap: 50px;
  width: max-content;
  animation: scrollMarquee 25s linear infinite;
  will-change: transform;
}

.slider-item {
  font-size: 1.05rem;
  font-family: 'Space Grotesk', sans-serif;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.6);
  letter-spacing: 0.1em;
  white-space: nowrap;
  display: flex;
  align-items: center;
}

@keyframes scrollMarquee {
  0% { transform: translateX(0); }
  100% { transform: translateX(calc(-50% - 25px)); }
}

/* ==========================================================================
   2. WOW REVEALS (NORMAL SCROLLYTELLING)
   ========================================================================== */
.st-reveal-section {
  padding: 150px 0;
  background: var(--bg-dark);
  position: relative;
  overflow: hidden;
}
.st-bg-gradient {
  position: absolute; top:0; left:-20%; width:140%; height:100%;
  background: radial-gradient(ellipse at center, rgba(112,0,255,0.05) 0%, transparent 70%);
  pointer-events: none; z-index:0;
}

.st-reveal-container { position: relative; z-index: 10; }

.st-block {
  min-height: 60vh;
  display: flex;
  align-items: center;
  margin-bottom: 100px;
}
@media(max-width: 900px) {
  .st-block { margin-bottom: 80px; min-height: auto; }
}

.st-content {
  width: 100%; display: grid; grid-template-columns: 1fr 1fr; gap: 80px;
  align-items: center; 
  opacity: 0; transform: translateY(60px);
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1);
}
.st-content--right { grid-template-columns: 1fr 1fr; }

/* En movil apiilamos verticalmente siempre texto primero */
@media(max-width: 900px) {
  .st-content, .st-content--right {
    grid-template-columns: 1fr; gap: 40px;
  }
  .st-content--right .st-visual { grid-row: 2; }
  .st-content--right .st-text { grid-row: 1; }
}

.reveal-element.is-visible .st-content {
  opacity: 1; 
  transform: translateY(0);
}
.st-block.reveal-element.is-visible:hover .st-content { 
  transform: translateY(-5px); 
}

.st-num-wow {
  font-size: 4rem; font-weight: 900; color: transparent;
  -webkit-text-stroke: 1px rgba(255,255,255,0.1);
  line-height: 1; margin-bottom: 20px;
  background: linear-gradient(to bottom, #fff, transparent);
  -webkit-background-clip: text;
}

.st-title { font-size: clamp(2rem, 4vw, 3.5rem); font-weight: 800; line-height: 1.1; margin-bottom: 24px; letter-spacing: -0.03em;}
.st-text p { font-size: 1.2rem; color: var(--text-faint); line-height: 1.6; }

/* WOW Visuals inside Scrollytelling */
.glass-panel {
  background: rgba(255,255,255,0.03);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-glass);
  border-radius: 20px; padding: 40px;
  box-shadow: 0 30px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1);
  position: relative; overflow: hidden;
  transition: transform 0.5s ease;
}
.glass-panel:hover { transform: translateY(-10px) scale(1.02); }

.dark-panel { background: #0a0a0c; }

.mockup-header { font-weight: 700; margin-bottom: 20px; color: #fff; display: flex; align-items: center; gap:10px; }
.mockup-header::before { content:''; width:12px; height:12px; border-radius:50%; background: #27c93f; }
.mock-line { height: 12px; background: rgba(255,255,255,0.1); border-radius: 6px; margin-bottom: 12px; }
.pulse-line { background: rgba(112,0,255,0.3); animation: pulseWidth 2s infinite ease-in-out; }
@keyframes pulseWidth { 0%,100%{width:80%;} 50%{width:50%;} }
.mock-btn { margin-top: 30px; background: #fff; color: #000; padding: 12px; text-align: center; border-radius: 8px; font-weight: 700; display:flex; justify-content:center; align-items:center; gap:8px;}

.mockup-stats { display: flex; align-items: center; gap: 30px; }
.stat-circle { width: 100px; height: 100px; position: relative; }
.circle-bg { fill:none; stroke: rgba(255,255,255,0.1); stroke-width:3; }
.circle { fill:none; stroke: var(--brand-purple); stroke-width:3; stroke-linecap: round; animation: drawCircle 2s ease forwards; }
.stat-perc { position:absolute; inset:0; display:flex; align-items:center; justify-content:center; font-weight:700; font-size:1.2rem; color:#fff;}
.stat-lines { flex: 1; }

.scanner-mockup { display: flex; flex-direction: column; align-items: center; padding: 60px 40px; }
.scanner-frame { width: 150px; height: 150px; border: 2px dashed rgba(255,255,255,0.3); border-radius: 20px; position:relative; display:flex; align-items:center; justify-content:center;}
.qr-icon { font-size: 4rem; color: rgba(255,255,255,0.5); }
.scanner-laser { position:absolute; top:0; left:0; width:100%; height:2px; background: #00e5ff; box-shadow: 0 0 20px #00e5ff; animation: laserScan 2s infinite linear; }
@keyframes laserScan { 0%{top:0;} 50%{top:100%;} 100%{top:0;} }
.scanner-status { margin-top: 30px; font-weight: 700; color: #00e5ff; background: rgba(0,229,255,0.1); padding: 8px 16px; border-radius: 999px;}

/* ==========================================================================
   3. HORIZONTAL SCROLL (DESKTOP STICKY / MOBILE SNAP)
   ========================================================================== */
.horizontal-wrap {
  position: relative;
  height: 350vh;
  background: var(--bg-dark);
}

.mobile-story-wrap {
  padding: 24px 0 40px;
  background: var(--bg-dark);
  overflow: hidden;
}

.mobile-story-stack {
  display: grid;
  gap: 8px;
}

.mobile-story-step {
  min-height: auto;
  display: flex;
  align-items: center;
  position: relative;
  padding: 8px 0;
}

.mobile-story-header {
  margin-bottom: 10px;
}

.mobile-story-step::before {
  content: '';
  position: absolute;
  inset: 8% 8% auto;
  height: 58%;
  background: radial-gradient(circle at top, rgba(112,0,255,0.16), transparent 72%);
  filter: blur(18px);
  opacity: 0;
  transform: scale(0.9);
  transition: opacity 0.8s ease, transform 0.8s ease;
  pointer-events: none;
}

.mobile-story-step.reveal-element.is-visible::before {
  opacity: 1;
  transform: scale(1);
}

.mobile-story-step:nth-child(2)::before {
  background: radial-gradient(circle at top, rgba(112,0,255,0.22), transparent 72%);
}

.mobile-story-step:nth-child(3)::before {
  background: radial-gradient(circle at top, rgba(39,201,63,0.18), transparent 72%);
}

.mobile-story-step:nth-child(4)::before {
  background: radial-gradient(circle at top, rgba(0,229,255,0.18), transparent 72%);
}

.mobile-story-step::after {
  content: '';
  position: absolute;
  inset: auto 18px 0;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.12), transparent);
  opacity: 0.45;
}

.mobile-story-step:last-child::after {
  display: none;
}

@media(max-width: 900px) {
  .mobile-story-step .container {
    width: 100%;
    max-width: none;
    padding-left: 16px;
    padding-right: 16px;
    overflow: visible;
    box-sizing: border-box;
  }

  .h-card,
  .lux-bento {
    width: calc(100vw - 32px);
    max-width: calc(100vw - 32px);
    margin-left: auto;
    margin-right: auto;
    box-sizing: border-box;
  }

  .h-card-visual {
    height: 198px;
    transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1), filter 1s ease, opacity 1s ease;
  }

  .h-card-text {
    padding: 22px 18px 20px;
    transition: transform 0.95s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.95s ease;
  }

  .h-card-text h3 {
    font-size: 1.35rem;
  }

  .h-card-text p {
    font-size: 1rem;
    max-width: none;
  }

  .mobile-story-step {
    min-height: auto;
  }

  .mobile-story-step .lux-bento {
    transform: perspective(1000px) rotateX(14deg) scale(0.94) translateY(42px);
    transform-origin: center center;
    opacity: 0;
    filter: blur(10px) saturate(0.88);
    transition: transform 1s cubic-bezier(0.16, 1, 0.3, 1), opacity 1s ease, box-shadow 1s ease, border-color 1s ease, background 1s ease, filter 1s ease;
  }

  .mobile-story-step:nth-child(even) .lux-bento {
    transform: perspective(1000px) rotateX(14deg) scale(0.94) translateY(42px);
  }

  .mobile-story-step.reveal-element.is-visible .lux-bento {
    transform: perspective(900px) rotateX(0deg) translateX(0) scale(1);
    opacity: 1;
    filter: blur(0) saturate(1);
    border-color: rgba(112,0,255,0.18);
    box-shadow: 0 26px 56px rgba(0,0,0,0.55), 0 0 34px rgba(112,0,255,0.1);
    background: linear-gradient(180deg, rgba(18,18,20,0.98) 0%, rgba(14,14,16,1) 100%);
  }

  .mobile-story-step.reveal-element.is-visible .h-card-visual {
    transform: scale(1.05) translateY(-6px);
    filter: saturate(1.14) brightness(1.05);
    opacity: 1;
  }

  .mobile-story-step .h-card-text {
    opacity: 0;
    transform: translateY(24px);
  }

  .mobile-story-step.reveal-element.is-visible .h-card-text {
    opacity: 1;
    transform: translateY(0);
  }

  .mobile-story-step .h-card-text h3,
  .mobile-story-step .h-card-text p {
    opacity: 0;
    transform: translateY(22px);
    transition: transform 0.95s cubic-bezier(0.16, 1, 0.3, 1), opacity 0.95s ease;
  }

  .mobile-story-step.reveal-element.is-visible .h-card-text h3 {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.08s;
  }

  .mobile-story-step.reveal-element.is-visible .h-card-text p {
    opacity: 1;
    transform: translateY(0);
    transition-delay: 0.18s;
  }

  .mobile-story-step:nth-child(1).reveal-element.is-visible .lux-bento {
    box-shadow: 0 24px 56px rgba(0,0,0,0.56), 0 0 36px rgba(112,0,255,0.08);
  }

  .mobile-story-step:nth-child(2).reveal-element.is-visible .lux-bento {
    box-shadow: 0 24px 56px rgba(0,0,0,0.56), 0 0 40px rgba(112,0,255,0.16);
  }

  .mobile-story-step:nth-child(3).reveal-element.is-visible .lux-bento {
    box-shadow: 0 24px 56px rgba(0,0,0,0.56), 0 0 38px rgba(39,201,63,0.14);
  }

  .mobile-story-step:nth-child(4).reveal-element.is-visible .lux-bento {
    box-shadow: 0 24px 56px rgba(0,0,0,0.56), 0 0 38px rgba(0,229,255,0.14);
  }
}

.sticky-box {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  will-change: transform;
}

.h-scroll-header { margin-bottom: 60px; z-index: 10; }
.h-title { font-size: clamp(2.5rem, 5vw, 4rem); font-weight: 800; letter-spacing: -0.03em; margin-bottom: 16px; }
.h-subtitle { font-size: 1.25rem; color: var(--text-faint); max-width: 600px; }

.scroll-track { display: flex; gap: 40px; padding: 0 40px; width: max-content; will-change: transform; transition: transform 0.1s ease-out; }
.h-card-slot { display: contents; }

.lux-bento {
  width: 450px;
  background: var(--bg-panel-solid);
  border: 1px solid var(--border-glass);
  border-radius: 24px;
  overflow: hidden; display: flex; flex-direction: column;
  transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
  box-shadow: 0 20px 40px rgba(0,0,0,0.5);
}
.lux-bento.reveal-element {
  opacity: 0;
  transform: translateY(36px);
  transition: opacity 0.8s ease, transform 0.8s ease, border-color 0.4s ease, box-shadow 0.4s ease;
}
.lux-bento.reveal-element.is-visible {
  opacity: 1;
  transform: translateY(0);
}
.lux-bento:hover { transform: translateY(-10px); border-color: rgba(112,0,255,0.4); box-shadow: 0 30px 60px rgba(0,0,0,0.8), 0 0 40px rgba(112,0,255,0.1); }

.h-card-visual { height: 280px; position: relative; background: #000; display:flex; align-items:center; justify-content:center; overflow:hidden;}
.lux-glow { position:absolute; inset:0; background: radial-gradient(circle at center, rgba(255,255,255,0.1), transparent 70%); }
.lux-glow-purple { background: radial-gradient(circle at center, rgba(112,0,255,0.2), transparent 70%); }
.lux-glow-green { background: radial-gradient(circle at center, rgba(39,201,63,0.15), transparent 70%); }
.lux-glow-blue { background: radial-gradient(circle at center, rgba(0,229,255,0.15), transparent 70%); }

.h-card-text { padding: 40px 32px; background: rgba(255,255,255,0.02); flex:1; border-top: 1px solid var(--border-glass);}
.h-card-text h3 { font-size: 1.5rem; font-weight: 700; margin-bottom: 16px; color:#fff;}
.h-card-text p { color: var(--text-faint); font-size: 1.05rem; line-height: 1.6; margin:0;}

/* Card 1: Ticket 3D */
.ui-ticket-3d { width: 80%; background: linear-gradient(135deg, #1a1a20, #0a0a0c); border: 1px solid rgba(255,255,255,0.1); border-radius: 16px; padding:24px; position:relative; box-shadow: 0 20px 40px rgba(0,0,0,0.5); transform: perspective(1000px) rotateX(10deg) rotateY(-10deg); transition: transform 0.5s ease;}
.lux-bento:hover .ui-ticket-3d { transform: perspective(1000px) rotateX(0) rotateY(0); }
.ticket-top { display:flex; justify-content:space-between; align-items:center; margin-bottom:30px; border-bottom:1px dashed rgba(255,255,255,0.2); padding-bottom:16px;}
.ticket-top strong { color:#fff; font-size:1.1rem;}
.badge-urgency { background: rgba(255,50,100,0.2); color: #ff3264; font-size:0.75rem; padding:4px 8px; border-radius:4px; font-weight:700;}
.ticket-mid { text-align:left;}
.ui-price { font-size: 2rem; font-weight:800; color:#fff; display:block; margin-bottom:16px;}
.ui-bar { height: 8px; background: rgba(255,255,255,0.1); border-radius: 4px; overflow:hidden;}
.ui-fill { height: 100%; background: var(--brand-purple); width: 85%; }
.anim-fill-1 { animation: fillWidth 3s infinite alternate ease-in-out; }
@keyframes fillWidth { 0%{width:30%;} 100%{width:95%;} }

/* Card 2: Magic Promo */
.magic-promo-box { position:relative; width:100%; height:100%;}
.floating-tag { position:absolute; background:rgba(255,255,255,0.05); backdrop-filter:blur(10px); border:1px solid rgba(255,255,255,0.1); padding: 12px 20px; border-radius:999px; font-weight:700; color:#fff; box-shadow: 0 10px 30px rgba(0,0,0,0.5);}
.f-tag-1 { top: 30%; left: 10%; animation: floatY 4s infinite ease-in-out; }
.f-tag-2 { top: 60%; right: 10%; animation: floatY 5s infinite ease-in-out reverse; background: rgba(112,0,255,0.2); border-color:var(--brand-purple);}
.f-tag-3 { bottom: 10%; left: 30%; animation: floatY 3.5s infinite ease-in-out 1s; }
.hidden-style { border-style:dashed; }
@keyframes floatY { 0%,100%{transform:translateY(0);} 50%{transform:translateY(-20px);} }

/* Card 3: 3D Chart */
.chart-3d { display:flex; align-items:flex-end; gap:20px; height:120px; transform: perspective(1000px) rotateX(20deg); transition: transform 0.5s ease;}
.lux-bento:hover .chart-3d { transform: perspective(1000px) rotateX(0deg); }
.bar-3d { width: 40px; position:relative; background: rgba(255,255,255,0.1); border-radius: 4px 4px 0 0;}
.highlight-bar { background: var(--brand-purple); box-shadow: 0 0 30px rgba(112,0,255,0.5); }

/* Card 4: Ecosystem Core */
.integration-ui { position:relative; overflow:hidden;}
.grid-mesh-bg { position:absolute; inset:0; background: linear-gradient(rgba(255,255,255,0.05) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.05) 1px, transparent 1px); background-size: 20px 20px; transform: perspective(500px) rotateX(60deg); transform-origin: top; opacity:0.5;}
.fomo-core-logo { position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); width:60px; height:60px; background:#fff; border-radius:50%; display:flex; align-items:center; justify-content:center; font-size:2rem; font-weight:900; color:#000; box-shadow:0 0 30px #fff; z-index:5;}
.orbit { position:absolute; top:50%; left:50%; border:1px solid rgba(255,255,255,0.1); border-radius:50%; transform:translate(-50%,-50%); }
.orbit-1 { width:140px; height:140px; animation: spinOrb 10s linear infinite; }
.orbit-2 { width:220px; height:220px; border-style:dashed; animation: spinOrb 15s linear infinite reverse; }
.orbit::before { content:''; position:absolute; top:-5px; left:50%; width:10px; height:10px; background:var(--brand-cyan); border-radius:50%; box-shadow:0 0 10px var(--brand-cyan);}
@keyframes spinOrb { 100%{transform:translate(-50%,-50%) rotate(360deg);} }

/* ==========================================================================
   4. TRANSPARENT PRICING
   ========================================================================== */
.mega-pricing {
  padding: 150px 0;
  background: var(--bg-dark);
  position: relative;
}
.pricing-bg-fx { position:absolute; inset:0; background: radial-gradient(circle at bottom right, rgba(112,0,255,0.1) 0%, transparent 60%); pointer-events:none;}
.pricing-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 100px;
  align-items: center;
}
@media(max-width: 900px) { .pricing-grid { grid-template-columns: 1fr; gap: 60px; } }

.pricing-content h2 { font-size: clamp(3rem, 5vw, 4.5rem); font-weight: 900; letter-spacing: -0.04em; margin-bottom: 24px; line-height: 1; }
.pricing-content p { font-size: 1.25rem; color: var(--text-faint); margin-bottom: 40px; line-height: 1.6; max-width: 500px;}
.pricing-list { list-style: none; padding: 0; margin: 0; }
.pricing-list li { display: flex; align-items: flex-start; gap: 16px; font-size: 1.15rem; margin-bottom: 24px; color: #fff; }
.glow-icon { color: var(--brand-purple); margin-top: 4px; font-size:1.4rem; text-shadow: 0 0 15px var(--brand-purple);}

/* Animations for remaining sections */
.pricing-content.reveal-element, 
.pricing-card-wrapper.reveal-element, 
.cta-content-box.reveal-element { 
  opacity: 0; 
  transform: translateY(50px); 
  transition: all 1s cubic-bezier(0.16, 1, 0.3, 1); 
}
.pricing-content.reveal-element.is-visible, 
.pricing-card-wrapper.reveal-element.is-visible, 
.cta-content-box.reveal-element.is-visible { 
  opacity: 1; 
  transform: translateY(0); 
}

.wow-tilt {
  background: rgba(255,255,255,0.02); backdrop-filter: blur(30px);
  border: 1px solid var(--border-glass);
  padding: 80px 40px;
  border-radius: 32px;
  text-align: center;
  position: relative;
  box-shadow: 0 30px 60px rgba(0,0,0,0.5), inset 0 1px 0 rgba(255,255,255,0.1);
  overflow: hidden;
}
.glass-glare { position:absolute; top:0; left:-100%; width:50%; height:100%; background: linear-gradient(to right, transparent, rgba(255,255,255,0.1), transparent); transform: skewX(-20deg); animation: glareSweep 8s infinite;}
@keyframes glareSweep { 0%,50%{left:-100%;} 100%{left:200%;} }

.price-display { display: flex; align-items: flex-start; justify-content: center; line-height: 0.8;}
.amount { font-size: 10rem; font-weight: 900; letter-spacing: -0.05em; background: linear-gradient(to bottom, #fff, #888); -webkit-background-clip: text; -webkit-text-fill-color: transparent;}
.currency { font-size: 3rem; font-weight: 700; color: var(--text-faint); margin-top:20px;}
.period { font-size: 2rem; color: var(--text-faint); font-weight: 600; align-self: flex-end;}
.fee-text { color: var(--text-faint); font-size: 1.1rem; margin: 30px 0 50px; }
.full-width-wow { width: 100%; height: 60px !important; font-size: 1.1rem !important;}

/* ==========================================================================
   5. FINAL PUSH
   ========================================================================== */
.mega-cta {
  padding: 250px 0;
  text-align: center;
  position: relative;
  background: var(--bg-dark);
}
.mega-cta-bg {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 100vw; height: 100vw;
  background: radial-gradient(circle, rgba(112,0,255,0.15) 0%, transparent 50%);
  filter: blur(80px);
  z-index: 0; pointer-events:none;
}
.cta-content-box { position: relative; z-index: 10; }
.megatext-reveal { font-size: clamp(3.5rem, 8vw, 7rem); font-weight: 900; letter-spacing: -0.04em; margin-bottom: 60px; line-height: 1; color:#fff;}
.highlight-soldout { color: var(--brand-cyan); text-shadow: 0 0 40px rgba(0,229,255,0.4); }
.mega-cta__support {
  max-width: 820px;
  margin: -28px auto 42px;
  color: var(--text-faint);
  font-size: 1.2rem;
  line-height: 1.6;
}

/* ==========================================================================
   6. PREMIUM BUTTON SAAS
   ========================================================================== */
.saas-premium-btn {
  appearance: none; background: #fff; color: #000;
  border: none; border-radius: 999px;
  padding: 18px 42px; font-size: 1.15rem; font-weight: 700;
  letter-spacing: -0.02em; display: inline-flex;
  align-items: center; justify-content: center; gap: 12px;
  cursor: pointer; font-family: inherit;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.1), 0 8px 24px rgba(255, 255, 255, 0.15);
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}
.saas-premium-btn:hover {
  transform: translateY(-2px) scale(1.02);
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.2), 0 12px 32px rgba(255, 255, 255, 0.25);
  background: #f0f0f0; color: #000;
}
.saas-premium-btn i {
  font-size: 1.1rem; transition: transform 0.3s ease;
}
.saas-premium-btn:hover i { transform: translateX(5px); }

.saas-premium-btn.btn-massive {
  padding: 24px 64px; font-size: 1.35rem; margin-top: 50px;
}
.saas-premium-btn.btn-massive i { font-size: 1.25rem; }

</style>
